@file:OptIn(InternalResourceApi::class)

package ifaandroid.feature.today_v2.today_ui_fodmap.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/ifaandroid.feature.today_v2.today_ui_fodmap.generated.resources/"

@delegate:ResourceContentHash(-1_873_189_562)
internal val Res.drawable.bg_calendar: DrawableResource by lazy {
      DrawableResource("drawable:bg_calendar", setOf(
        ResourceItem(setOf(), "${MD}drawable/bg_calendar.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("bg_calendar", Res.drawable.bg_calendar)
}
